import React from "react";
import Loader1 from "../../components/Loader1";
import Card from "./Card";

const ErrorCard = ({axiosError}) => {
  return (
    <Card padding>
      <h4>Hubo un error</h4>
      <h6>Codigo {axiosError.code}</h6>
    </Card>
  )
}

const AsyncBlock = ({children, loading, error}) => {

  const firstvalue = error ? <ErrorCard axiosError={error}/> : children
  return (
    !loading
      ?
      firstvalue
      :
      <Loader1/>
  )
}

export default AsyncBlock
